import classnames from "classnames"

import styles from "./Button.module.scss"

type ButtonProps = {
  children: React.ReactNode
  className?: string
  emphasis?: "medium" | "low" | "high"
  variant?: "primary" | "secondary"
  value?: any
  style?: React.CSSProperties
  type?: any
  form?: string
  onClick?: (e: any) => void
  disabled?: boolean
  size?: string
  formNoValidate?: boolean
  name?: string
}

// FIXME: 之後都用 go-design
const Button = (props: ButtonProps) => {
  const {
    children,
    className,
    emphasis = "medium",
    variant = "",
    style,
    type,
    form,
    value,
    onClick,
    disabled,
    size = "",
    formNoValidate,
    name,
    ...restProps
  } = props

  return (
    <button
      className={classnames(styles.button, styles[emphasis], styles[variant], styles[size], className)}
      disabled={disabled}
      type={type || "button"}
      form={form}
      value={value}
      style={style}
      onClick={onClick}
      formNoValidate={formNoValidate}
      name={name}
      {...restProps}>
      {children}
    </button>
  )
}

export default Button
